import reactStringReplace from 'react-string-replace'

import { Props as AnswerProps } from '../..'

const MissingWord = ({ answer, question }: AnswerProps) => {
  // used to count input fields
  let fields = 0

  return (
    <div>
      {reactStringReplace(question.title, /(\{=[^\}]+\})/g, (_match) => {
        const matchAnswer = answer?.[fields++]

        if (!Boolean(matchAnswer)) {
          return <em key={fields}>---</em>
        }

        return (
          <span className="font-medium underline" key={fields}>
            {matchAnswer}
          </span>
        )
      })}
    </div>
  )
}

export default MissingWord
